export enum CesiumCursor {
  default = "default",
  pointer = "pointer",
  none = "none",
}
